define('modules/media_picker/media_picker_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/util/collection/collection_view',
  './media_picker_collection_item_view',
  'modules/modal/modal_view',
  './media_picker_collection',
  'text!./media_picker_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  CollectionView,
  ItemView,
  ModalView,
  MediaCollection,
  template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      this.endpoints = [
        {
          endpoint: 'files',
          mediaType: 'myvideos',
          label: _.t('mediapicker.endpoint.local_media'),
          state: 'active',
          params: { location_id: session.get('location_id') },
        },
      ];

      if (this.endpoints.length) {
        //multiple tabs
        this.navigation = this.endpoints;
      }
      this.collection = new MediaCollection(
        {},
        { endpoint: this.endpoints[0].endpoint || this.endpoint }
      );
      this.collection.params = _.extend(
        this.collection.params,
        this.endpoints[0].params
      );
      if (this.params) {
        this.collection.params = _.extend(this.collection.params, this.params);
      }

      this.listenToOnce(
        this.collection,
        'sync',
        function () {
          this.initializeModal();
        },
        this
      );

      this.collection.fetch();
    },

    events: {
      'click .js-switch-endpoint': 'switchEndpoint',
    },

    template: _.template(template),
    className: 'MediaPickerModal',

    render: function () {
      this.$el.html(this.template({ navigation: this.navigation || null }));

      this.collectionView = new CollectionView({
        viewType: CollectionView.GRID,
        items: this.collection,
        itemView: ItemView,
        extraParams: {
          onSelect: this.onSelect,
        },
        options: {
          filter: false,
        },
      });
      this.$('.js-media-picker-content').html(this.collectionView.$el);

      return this;
    },

    renderList: function (mediaType) {
      this.collectionView = new CollectionView({
        viewType: CollectionView.GRID,
        items: this.collection,
        itemView: ItemView,
        extraParams: {
          onSelect: this.onSelect,
        },
        options: {
          filter: false,
          search: mediaType !== 'videos',
          searchTags: mediaType === 'videos',
        },
      });
      this.$('.js-media-picker-content').html(this.collectionView.$el);
      return this;
    },

    initializeModal: function () {
      this.modal = new ModalView({
        title: _.t('mediapicker.modal.header'),
        modalContent: this,
      });
      this.modal.open();
    },

    switchEndpoint: function (e) {
      e.preventDefault();
      var endpoint = $(e.currentTarget).data().endpoint;
      this.$('.media-picker-navigation .active').removeClass('active');
      $(e.currentTarget).addClass('active');

      var mediaType = $(e.currentTarget).data().mediaType;
      this.collection = new MediaCollection({}, { endpoint: endpoint });
      this.listenToOnce(
        this.collection,
        'sync',
        function () {
          this.collectionView.remove();
          this.renderList(mediaType);
        },
        this
      );

      this.collection.params = _.extend(
        this.collection.params,
        $(e.currentTarget).data().endpointParams
      );
      this.collection.fetch();
    },
  });
  return View;
});

